import dayjs from "dayjs";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/stores";
import { tenantMemberSelects, tenantMemberThunks } from "./store";
import { MemberRead } from "./types";
// components
import { Button, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { CreateModal } from "./CreateModal";

export const TenantManageMembersPage = () => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector(tenantMemberSelects.loading);

  const members = useAppSelector(tenantMemberSelects.members);

  useEffect(() => {
    void dispatch(tenantMemberThunks.list());
  }, [dispatch]);

  const columns: ColumnsType<MemberRead> = [
    {
      width: 150,
      title: "代碼",
      dataIndex: "id",
    },
    {
      width: 180,
      title: "帳號",
      dataIndex: "username",
    },
    {
      width: 180,
      title: "名稱",
      dataIndex: "name",
    },
    {
      title: "地址",
      dataIndex: "address",
    },
    {
      width: 90,
      align: "right",
      className: "v:top px:6!:is(td)",
      title: "建立時間",
      key: "created_at",
      sorter: () => 1,
      render(_, { created_at }) {
        return created_at ? <div>{dayjs.$ldts(created_at)}</div> : null;
      },
    },
    {
      width: 160,
      title: "",
      key: "action",
      render() {
        return (
          <div className="flex gap:8">
            <Button type="primary">修改</Button>
            <Button danger type="primary">
              刪除
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="flex flex:col gap:8">
      <div className="flex jc:end gap:8">
        <CreateModal />
      </div>

      <Table
        rowKey="id"
        tableLayout="fixed"
        loading={loading}
        columns={columns}
        dataSource={members}
        scroll={{ x: "1600px" }}
      ></Table>
    </div>
  );
};
